var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.type
        ? _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "" } },
                [
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "logisticsIndex" } } },
                    [_c("div", { staticClass: "div1" }, [_vm._v(" 返回首页 ")])]
                  ),
                  _c("el-breadcrumb-item", [
                    _c("div", { staticClass: "div2" }, [
                      _vm._v("库存告急列表"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "查询商品", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "查询赠品", name: "2" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "query" },
        [
          _c(
            "div",
            {
              staticStyle: {
                "border-bottom": "1px solid #eee",
                margin: "10px",
                "font-size": "14px",
                color: "#2d7edf",
              },
            },
            [_vm._v(" 查询信息 ")]
          ),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.queryForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "产品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入产品名称" },
                    model: {
                      value: _vm.queryForm.info,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "info", $$v)
                      },
                      expression: "queryForm.info",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "选择品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "value-key": "id",
                        clearable: "",
                        placeholder: "请选择品牌",
                        "default-first-option": "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.queryForm.service,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "service", $$v)
                        },
                        expression: "queryForm.service",
                      },
                    },
                    _vm._l(_vm.brand, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "商品仓库" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        "value-key": "id",
                        placeholder: "请选择商品仓库",
                        "default-first-option": "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.queryForm.warId,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "warId", $$v)
                        },
                        expression: "queryForm.warId",
                      },
                    },
                    _vm._l(_vm.op, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v(" 搜索 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "context" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.goods.list,
                "header-cell-style": { color: "#2E7EDF" },
              },
            },
            [
              _c("el-table-column", {
                key: "1",
                attrs: { label: "序号", width: "50", type: "index" },
              }),
              _c("el-table-column", {
                key: "2",
                attrs: { label: "商品图片", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: { src: _vm.img(scope.row.image), fit: "fit" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "3",
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "title",
                  "min-width": "150",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                key: "4",
                attrs: {
                  prop: "brandId",
                  label: "商品品牌",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                key: "5",
                attrs: {
                  prop: "sellPrice",
                  label: "商品单价",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                key: "6",
                attrs: { label: "商品规格", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v("盒")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "7",
                attrs: {
                  prop: "quantityStock",
                  "min-width": "120",
                  label: "商品库存",
                },
              }),
              !_vm.type && _vm.tableData.goods
                ? _c("el-table-column", {
                    key: "8",
                    attrs: {
                      prop: "updateTime",
                      label: "更新时间",
                      "min-width": "180",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                key: "9",
                attrs: { fixed: "right", label: "操作", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.type && _vm.tableData.goods
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                staticStyle: { display: "inline-block" },
                                attrs: {
                                  effect: "dark",
                                  content: "添加库存",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "30px",
                                      color: "#2E7EDF",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addInventory(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-shopping-cart-full",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.type &&
                        _vm.tableData.goods &&
                        _vm.parArray.findIndex((e) => e === "addStorage")
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                staticStyle: { display: "inline-block" },
                                attrs: {
                                  effect: "dark",
                                  content: "添加库存",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "30px",
                                      color: "#2E7EDF",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addInventory(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "添加库存",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择仓库" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "value-key": "id",
                        clearable: "",
                        placeholder: "请选择仓库",
                      },
                      on: { change: _vm.selectClick },
                      model: {
                        value: _vm.form.warId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "warId", $$v)
                        },
                        expression: "form.warId",
                      },
                    },
                    _vm._l(
                      JSON.parse(JSON.stringify(_vm.op)),
                      function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { value: items, label: items.name },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "wareHouse" },
                _vm._l(_vm.form.warIds, function (items, index) {
                  return _c(
                    "span",
                    { key: index },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: items.name } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入商品库存" },
                            model: {
                              value: items.quantityStock,
                              callback: function ($$v) {
                                _vm.$set(items, "quantityStock", $$v)
                              },
                              expression: "items.quantityStock",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购单" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入采购单" },
                    model: {
                      value: _vm.form.oddNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "oddNumber", $$v)
                      },
                      expression: "form.oddNumber",
                    },
                  }),
                ],
                1
              ),
              _vm.form.warId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "仓库负责人", "label-width": "82px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          placeholder: "请输入仓库负责人",
                        },
                        model: {
                          value: _vm.form.warId.keeper,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.warId, "keeper", $$v)
                          },
                          expression: "form.warId.keeper",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "采购人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入采购人" },
                    model: {
                      value: _vm.form.receive,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "receive", $$v)
                      },
                      expression: "form.receive",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addStorage },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tableData.goods
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-size": _vm.selectSizePage,
                    layout: "total,sizes,prev, pager, next",
                    "prev-text": "上一页",
                    "next-text": "下一页",
                    total: _vm.tableData.goods.totalNum,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                    "update:currentPage": function ($event) {
                      _vm.currentPage1 = $event
                    },
                    "update:current-page": function ($event) {
                      _vm.currentPage1 = $event
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("div", { staticStyle: { height: "50px" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }